import type { FC } from 'react';

interface IProps {
  width?: string;
  variant?: 'colored' | 'white';
  onClick?: () => void;
}

const variants = {
  colored: '/images/phyllome-logo-rgb.png',
  white: '/images/phyllome-logo-white-rgb.png',
};

const Logo: FC<IProps> = ({
  width = '100%',
  variant = 'colored',
  onClick = () => {},
}) => {
  return (
    <div style={{ display: 'inherit' }}>
      <img
        src={variants[variant]}
        alt='phyllome'
        onClick={onClick}
        style={{ width }}
      />
    </div>
  );
};

export default Logo;
